<script>
import { mapState, mapMutations } from "vuex";
import Summary from "@/components/ContractModals/Components/BaseParts/Summary";

export default {
  extends: Summary,
  computed: {
    ...mapState("PurchaseOrderSt2ContractModal", ["prices"])
  },
  methods: {
    ...mapMutations("PurchaseOrderSt2ContractModal", ["setSubtotal", "setVat", "setTotal"])
  }
};
</script>
